import React from 'react';

const TermsAndCondition = () => {
    return (
        <div className='mx-auto'>
            <h2 className='my-5 text-primary' > Tearms and Condition</h2>
            <p className='text-muted' > 
            Our Quality guaranteed products. You receaved with inteck packet. Paypal Actepted and 1 month replacement guarantee if damage product. 
            </p>
            
        </div>
    );
};

export default TermsAndCondition;